import React, { PropsWithChildren, Suspense } from 'react'
import {
  Await,
  defer,
  LoaderFunction,
  useLoaderData,
} from 'react-router-dom'
import {
  fetchInitialAuthStatus,
  IsUserAuthenticatedSelector,
} from '../../redux/authentication/AuthenticationSlice'
import { store } from '../../redux/store'
import { LoadingFallback } from '../shared/atom/LoadingFallback'
import { NavigateWithParams } from '../../utils/NavigateWithParams'

export const requireAuthLoader: LoaderFunction = async () => {
  const hasFetched = await store.dispatch(fetchInitialAuthStatus()).unwrap()
  return defer({
    fetchInitialAuthStatus: hasFetched,
  })
}

const RequireAuth = (props: PropsWithChildren) => {
  const isUserAuthenticated = IsUserAuthenticatedSelector()

  if (!isUserAuthenticated) {
    return (
      <NavigateWithParams
        to={`/login/create${window.location.search}`}
        replace
        state={{ from: window.location.pathname }}
      />
    )
  }

  return <>{props.children}</>
}

const AuthWrapper = (props: PropsWithChildren) => {
  const data = useLoaderData() as any

  return (
    <Suspense fallback={<LoadingFallback />}>
      <Await resolve={data.fetchInitialAuthStatus}>
        <RequireAuth>{props.children}</RequireAuth>
      </Await>
    </Suspense>
  )
}

export default AuthWrapper
